import { tokens } from '@cellula/react-theme-patient';
import styled from 'styled-components';
import { Fragment, ReactNode } from 'react';
import { HTTP_FILE_PATTERN, MAILTO_PATTERN, WWW_PATTERN } from '../../src/constants';
interface Props {
	text: string;
	linkElement?: (url: string, text: string) => ReactNode;
}

const elements = {
	messageAnchorTag: styled.a`
		color: ${tokens.color.content.interactive};
		transition: text-decoration 200ms;

		&:hover {
			color: ${tokens.color.content.interactive};
			text-decoration: underline;
		}
	`,
};

export function LinkInMessage({ text, linkElement, ...rest }: Props): JSX.Element {
	let finalText;
	const hasHTTPS = HTTP_FILE_PATTERN.test(text);
	const hasWWW = WWW_PATTERN.test(text);
	if (!hasHTTPS && !hasWWW) {
		finalText = text;
	} else {
		const splitRegEx = /([^\s]+)/g;
		let linkUrl = '',
			linkText = '';
		//divides the text to sections, then goes through every section and looks for link patterns to replace it with the given link/anchor tag component
		finalText = text.split(splitRegEx).map((current) => {
			if (HTTP_FILE_PATTERN.test(current) || MAILTO_PATTERN.test(current)) {
				linkUrl = current;
				linkText = current;
			} else if (WWW_PATTERN.test(current)) {
				linkUrl = 'https://' + current;
				linkText = current;
			} else {
				return current;
			}
			const formattedText =
				linkElement != null ? linkElement(linkUrl, linkText) : <DefaultLinkElement url={linkUrl} text={linkText} {...rest} />;

			return formattedText;
		});
	}

	return <Fragment>{finalText}</Fragment>;
}

interface defaultLinkProps {
	url: string;
	text: string;
}

function DefaultLinkElement({ url, text, ...rest }: defaultLinkProps): JSX.Element {
	return (
		<elements.messageAnchorTag href={url} target='_blank' rel='noreferrer' {...rest}>
			{text}
		</elements.messageAnchorTag>
	);
}
